export default {
  nakdanApiTrafficManager: 'https://nakdan-for-morph-analysis.loadbalancer.dicta.org.il/addnikud',
  morphApiTrafficManager: 'https://morph-analysis.loadbalancer.dicta.org.il'
}
